/**
 * values for setting the 'minAgeComparison' in Date(DOB)
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const AGE_COMPARISON = {
  CURRENT_DATE: 'current',
  CAMPAIGN_START_DATE: 'campaign'
};

const AGE_COMPARISON_ALL = _.values(AGE_COMPARISON, 'value');

const AGE_COMPARISON_LIST = [
  {text: locale('Current date'), value: AGE_COMPARISON.CURRENT_DATE, description: 'Compare age against current date'},
  {text: locale('Campaign start date'), value: AGE_COMPARISON.CAMPAIGN_START_DATE, description: 'Compare age against campaign start date'},
]

export { AGE_COMPARISON, AGE_COMPARISON_LIST, AGE_COMPARISON_ALL};

export default AGE_COMPARISON;